/**
 * Message lisible d'une erreur d'appel API : erreur en texte brut (routes historiques), sinon
 * premier motif de validation zod, sinon message du format REST ({ error: { message } }), sinon
 * message de l'exception, sinon `fallback`.
 */
export const getApiErrorMessage = (err, fallback) => {
  const apiError = err?.response?.data?.error;
  // Routes historiques : l'erreur est un simple texte ({ error: 'message' }).
  if (typeof apiError === 'string' && apiError) return apiError;
  const firstIssue = Array.isArray(apiError?.details) ? apiError.details[0]?.message : null;
  return firstIssue || apiError?.message || err?.message || fallback;
};

export default getApiErrorMessage;
